import { Box, DarkMode, LightMode } from '@chakra-ui/react'
import { HeroVisualSitemaps } from '@/-sections/Heroes/Sitemaps'
import Logos from '@/-sections/Logos'
import { Footer } from '@/-components/Footer'
import { JoinBanner } from '@/-sections/JoinBanner'
import { Collaboration } from '@/-sections/Collaboration'
import { Testimonials } from '@/-sections/Testimonials'
import { SitemapEditor } from '@/-sections/Sitemaps/Editor'

const Sitemaps = () => {
    return (
        <DarkMode>
            <Box w="full" bg="white">
                <Box w="full" bg="blue.600" py={{ base: 10, lg: 20 }} pb={{ base: 24, lg: 40 }}>
                    <HeroVisualSitemaps />
                </Box>
                <LightMode>
                    <Logos />
                    <Box py={{ base: 12, lg: 24 }}>
                        <SitemapEditor />
                    </Box>
                    <Collaboration />
                    <Testimonials />
                    <JoinBanner bgColor="#034024" />
                </LightMode>
            </Box>
            <Footer bgColor="#034024" />
        </DarkMode>
    )
}

export default Sitemaps